<template>
  <div class="col-md-9 col-lg-10 ml-md-auto">
    <div class="validation py-3 px-5 my-4" v-show="status">
      <p class="m-0">{{status}}</p>
    </div>
    <div class="new-property-form mb-4 p-3 mb-2 text-dark">
      <b-container fluid class="p-0">
        <b-form>
        <div class="bg-light p-4">
          <b-row>
            <b-col lg="2">
              <label class="m-0 font-weight-bold required">管理用物件名</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="data.property.administrative_title" :state="validateState('administrative_title')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('administrative_title')">
                <p v-if="!$v.data.property.administrative_title.required">管理用物件名は必須です</p>
                <p v-if="!$v.data.property.administrative_title.maxLength">100文字以下で入力してください</p>
                <p v-if="!$v.data.property.administrative_title.minLength">管理用物件名{{$v.data.property.administrative_title.$params.minLength.min}}文字以上入力してください</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">物件カテゴリ</label>
            </b-col>
            <b-col lg="4">
              <b-form-select :options="property_type" class="form-select" v-model="data.property.property_category" :state="validateState('property_category')"></b-form-select>
              <b-form-invalid-feedback :state="validateState('property_category')">
                <p v-if="!$v.data.property.property_category.required">物件カテゴリは必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">賃貸ステータス</label>
            </b-col>
            <b-col lg="4">
              <b-form-select :options="report_status" class="form-select" v-model="data.property.report_status"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="align-items-center d-flex mt-3">
            <b-col lg="2">
              <label class="m-0 required">都道府県</label>
            </b-col>
            <b-col lg="4">
              <b-form-select :options="prefecture" class="form-select" v-model="data.property.prefecture" :state="validateState('prefecture')"></b-form-select>
              <b-form-invalid-feedback :state="validateState('prefecture')">
                <p v-if="!$v.data.property.prefecture.required">都道府県は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </div>
        <div class="bg-light p-4">
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">作成言語</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="data.property.language" :options="language" class="form-select" :state="validateState('language')"></b-form-select>
                <b-form-invalid-feedback :state="validateState('language')">
                  <p v-if="!$v.data.property.language.required">作成言語は必須です</p>
                </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">表示物件名</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="data.property.property_name" :state="validateState('property_name')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('property_name')">
                <p v-if="!$v.data.property.property_name.required">表示物件名は必須です</p>
                <p v-if="!$v.data.property.property_name.maxLength">100文字以下で入力してください</p>
                <p v-if="!$v.data.property.property_name.minLength">表示物件名{{$v.data.property.property_name.$params.minLength.min}}文字以上入力してください</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">賃料</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.rent" :state="validateState('rent')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('rent')">
                <p v-if="!$v.data.property.rent.required">賃料は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2">
              <label class="m-0">坪賃料</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.tsubo_rent" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">管理費／共益費</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.administrative_fee" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">坪管理費／共益費</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.tsubo_management_fee" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">敷金</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.security_deposit" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">礼金</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.key_money"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" class=" d-flex">
              <label class="m-0">コピー</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.copy" rows="6">
              </b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">メイン画像</label>
            </b-col>
            <b-col lg="10">
              <b-form-file @change="uploadImage" accept=".jpg, .png, .gif" placeholder="ファイルを選択してください" required></b-form-file>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">メイン画像キャプション</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="data.property.mainImage[0].label"></b-form-input>
            </b-col>
          </b-row>
          <div v-for="(image, index) in data.property.subImage" :key="index">
            <b-row>
              <b-col lg="2">
                <label class="m-0">サブ画像{{ index + 1 }}</label>
              </b-col>
              <b-col lg="10" class="d-flex align-items-center ml-auto">
                <b-form-file @change="uploadImagesub($event, index)" accept=".jpg, .png, .gif" placeholder="ファイルを選択してください" required></b-form-file>
                <span v-if="data.property.subImage.length !== 1" class="btn btn-danger ml-2" @click="deleteImage(index)"><b-icon icon="dash" scale="2"></b-icon></span>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="2">
                <label class="m-0">サブ画像キャプション{{ index + 1 }}</label>
              </b-col>
              <b-col lg="10">
                <b-form-input class="form-input" v-model="image.label"></b-form-input>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col lg="10" class="ml-auto">
              <span class="btn btn-primary btn-block" @click="addImage()"><b-icon icon="plus" scale="2"></b-icon></span>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">住所</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="data.property.street_address"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">最寄り駅</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.nearest_station" rows="6"></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">その他料金</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.other_fee" rows="6"></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">方位</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.bearing"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">物件種別</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.property_type"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">構造</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.construction" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">階建て／階部分</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.building_floor_portion"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">駐車場</label>
            </b-col>
            <b-col lg="10" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.parking_lot"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">築年月</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.date_of_construction"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">契約期間</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.term_of_agreement" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">取引形態</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.form_of_transaction"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">業者付け</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.vendor_assignment"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">保証金</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.guarantee_deposit" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">償却</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.amortization" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">保険</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.insurance" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">専有面積</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.occupied_area" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">土地面積</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.land_area" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">総戸数</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.total_unit" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">引き渡し時期</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.delivery_time" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">現況</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.current_situation" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">造作譲渡</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.assignment_of_fixture" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">用途地域</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.area_of_use" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">特記事項</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.special_remarks" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">出店可能業種</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.openable_industry" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">内装状態</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.interior_condition" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">接道状況</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.roadside_situation" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">設備</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.facility" rows="6"></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">条件</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.condition" rows="6"></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">備考</label>
            </b-col>
            <b-col lg="10" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.remarks"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">情報提供日</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-datepicker v-model="data.property.provided_on" placeholder="日付を選択してください"></b-form-datepicker>
            </b-col>
            <b-col lg="2">
              <label class="m-0">次回更新日</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-datepicker v-model="data.property.next_update_on" placeholder="日付を選択してください"></b-form-datepicker>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">Googleマップの埋め込み用HTML</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea type="text" class="form-input" @input="validateMap($event)"></b-form-textarea>
              <small class="form-text text-muted">Googleマップの共有メニューからHTMLをコピーして貼り付けてください。Googleマップ用のURLが自動で埋まります。</small>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">Googleマップ用のURL</label>
            </b-col>
            <b-col lg="10">
              <b-form-input type="text" class="form-input" v-model="data.property.google_map_url" :state="validateState('google_map_url')"></b-form-input>
            </b-col>
          </b-row>
        </div>
        </b-form>
    </b-container>
    </div>
    <div class="d-flex justify-content-start align-items-center mb-4">
      <a href="#scroll" class="text-white text-decoration-none" v-smooth-scroll><b-button class="py-3 px-5 mr-3" variant="primary" @click="draft">下書き保存</b-button></a>
      <a href="#scroll" class="text-white text-decoration-none" v-smooth-scroll><b-button class="py-3 px-5" variant="success" @click="publish">公開</b-button></a>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength, url } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { prefectures, rentalCommercialPropertyValues } from '../../../assets/data/values'

export default {
  data () {
    return {
      mainImage: null,
      noFiles: null,
      subImage: [],
      data: {
        property: {
          type: this.$route.params.type,
          administrative_title: null,
          property_category: null,
          report_status: null,
          prefecture: null,
          property_name: null,
          rent: null,
          administrative_fee: null,
          security_deposit: null,
          key_money: null,
          copy: null,
          street_address: null,
          nearest_station: null,
          intermediary_charge: null,
          guarantee_consignment_fee: null,
          nonlife_insurance: null,
          renewal_fee: null,
          renewal_office_fee: null,
          other_fee: null,
          floor_plan_details: null,
          bearing: null,
          property_type: null,
          construction: null,
          building_floor_portion: null,
          parking_lot: null,
          date_of_construction: null,
          time_of_tenancy: null,
          room_category: null,
          type_of_contract: null,
          term_of_agreement: null,
          contract_deadline: null,
          update_type: null,
          form_of_transaction: null,
          vendor_assignment: null,
          facility: null,
          condition: null,
          school_district: null,
          remarks: null,
          provided_on: null,
          next_update_on: null,
          google_map_url: null,
          language: null,
          mainImage: [{
            url: '',
            label: ''
          }],
          subImage: [{
            url: '',
            label: ''
          }]
        }
      },
      property_type: [{ text: this.$i18n.t('please_choose'), disabled: true }].concat(rentalCommercialPropertyValues.propertyTypes),
      report_status: [{ text: this.$i18n.t('please_choose') }].concat(rentalCommercialPropertyValues.reportStatus.map(v => { return { value: v, text: this.$i18n.t(v) } })),
      prefecture: [{ text: this.$i18n.t('please_choose'), disabled: true }].concat(prefectures.map(p => { return { value: p, text: this.$i18n.t(p.charAt(0).toUpperCase() + p.slice(1)) } })),
      language: [
        { value: null, text: this.$i18n.t('please_choose'), disabled: true },
        { value: 'name_ja', text: '日本語' },
        { value: 'name_en', text: '英語' },
        { value: 'name_zh-cn', text: '簡体中文' },
        { value: 'name_zh-tw', text: '繫体中文' }
      ],
      status: null
    }
  },
  validations: {
    data: {
      property: {
        administrative_title: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        property_category: { required },
        prefecture: { required },
        language: { required },
        property_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(100)
        },
        rent: {
          required
        },
        google_map_url: { url }
      }
    }
  },
  methods: {
    ...mapActions('adminProperty', ['addProperty']),
    validateState (name) {
      const { $dirty, $error } = this.$v.data.property[name]
      return $dirty ? !$error : null
    },
    uploadImage: function (event) {
      if (event.target.files.length === 0) return

      this.mainImage = event.target.files[0]
      this.data.property.mainImage[0].url = this.mainImage.name
      this.noFiles = !event.target.files[0]
    },
    uploadImagesub: function (event, index) {
      if (event.target.files.length === 0) return

      const imageFile = event.target.files[0]
      this.subImage.push(imageFile)
      this.data.property.subImage[index].url = imageFile.name.replace(/ /g, '_')
    },
    validateMap ($event) {
      if ($event === null) {
        return
      }

      const result = $event.match(/src="([^"]+)"/)
      if (!result) {
        return
      }
      this.data.property.google_map_url = result[1]
    },
    publish () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.data.property.page_status = 'published'
        const dataList = { newData: this.data, mainImage: this.mainImage, subImage: this.subImage }
        this.addProperty({ data: dataList, apiType: 'admin' })
        this.resetFields()
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    draft () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.data.property.page_status = 'draft'
        const dataList = { newData: this.data, mainImage: this.mainImage, subImage: this.subImage }
        this.addProperty({ data: dataList, apiType: 'admin' })
        this.resetFields()
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    addImage () {
      this.data.property.subImage.push({
        url: '',
        label: ''
      })
    },
    resetFields () {
      this.data.property = {
        mainImage: [{
          url: '',
          label: ''
        }],
        subImage: [{
          url: '',
          label: ''
        }]
      }
    },
    deleteImage (index) {
      this.data.property.subImage.splice(index, 1)
      this.subImage.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.bg-light:first-child {
  margin-bottom: 1rem;
}
.bg-light .row {
  margin-bottom: .8rem;
  align-items: center;
}
.bg-light > .row:last-child {
  margin-bottom: 0;
}
</style>
